import React from 'react';
import { I18n } from 'react-redux-i18n';

import { I18N_BASE } from '../../constants';
import { LockHolder, LockState } from '../../models';
import CmButton from '../../components/primitives/CmButton';
import styles from './review.module.css';

export interface LockBannerProps {
  state: LockState;
  holder: LockHolder | null;
  onRetry?: () => void;
  testId?: string;
}

export function LockBanner({
  state,
  holder,
  onRetry,
  testId,
}: LockBannerProps): React.ReactElement | null {
  if (state === 'HeldByOther') {
    return (
      <div
        className={`${styles.banner} ${styles.bannerWarn} ${styles.bannerRow}`}
        data-testid={testId}
        data-banner="heldByOther"
      >
        <div>
          {I18n.t(`${I18N_BASE}.detail.lockBanner.heldByOther`, {
            reviewer:
              holder?.reviewerName
              ?? I18n.t(`${I18N_BASE}.general.unknownReviewer`),
          })}
        </div>
      </div>
    );
  }
  if (state === 'HeartbeatFailed') {
    return (
      <div
        className={`${styles.banner} ${styles.bannerError} ${styles.bannerRow}`}
        data-testid={testId}
        data-banner="heartbeatFailed"
      >
        <div>{I18n.t(`${I18N_BASE}.detail.lockBanner.heartbeatFailed`)}</div>
        {onRetry ? (
          <CmButton variant="ghost" onClick={onRetry} testId="lock-banner-retry">
            {I18n.t(`${I18N_BASE}.detail.lockBanner.retry`)}
          </CmButton>
        ) : null}
      </div>
    );
  }
  return null;
}

export default LockBanner;
